/** The token of the folder page (/folder/…), or null on any other page. */
export function folderToken(pathname: string): string | null {
  const match = /^\/folder\/([A-Za-z0-9_.-]{10,200})\/?$/.exec(pathname);
  return match ? match[1]! : null;
}
